export default __webpack_public_path__ + "static/media/profit.2f50de39.wav";